(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bfcm-countdown"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var pad = function (value) {
      return String(value).padStart(2, '0');
    };

    var banners = document.querySelectorAll('.bfcm-banner[data-bfcm-end]');

    banners.forEach(function (banner) {
      var target = Date.parse(banner.getAttribute('data-bfcm-end'));

      if (Number.isNaN(target)) return;

      var daysEl = banner.querySelector('[data-bfcm-days]');
      var hoursEl = banner.querySelector('[data-bfcm-hours]');
      var minutesEl = banner.querySelector('[data-bfcm-minutes]');
      var secondsEl = banner.querySelector('[data-bfcm-seconds]');
      var intervalId;

      var finish = function () {
        banner.setAttribute('data-bfcm-over', 'true');
        if (intervalId) window.clearInterval(intervalId);
      };

      var tick = function () {
        var remaining = target - Date.now();

        if (remaining <= 0) {
          finish();
          return;
        }

        var totalSeconds = Math.floor(remaining / 1000);

        daysEl.textContent = Math.floor(totalSeconds / 86400);
        hoursEl.textContent = pad(Math.floor((totalSeconds % 86400) / 3600));
        minutesEl.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
        secondsEl.textContent = pad(totalSeconds % 60);
      };

      tick();

      if (banner.getAttribute('data-bfcm-over') !== 'true') {
        intervalId = window.setInterval(tick, 1000);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
